import React from 'react';
import { ArrowRight, ArrowDown } from 'lucide-react';

const ROOMS = [
  { name: 'Mémoire', code: '01', tone: 'bg-pine-600 text-parchment' },
  { name: 'Focus', code: '02', tone: 'bg-paper text-ink border border-sand' },
  { name: 'Logique', code: '03', tone: 'bg-copper-500 text-paper' },
  { name: 'Calme', code: '04', tone: 'bg-moss text-paper' },
  { name: 'Agora', code: '05', tone: 'bg-paper text-ink border border-sand' },
  { name: 'Bilan', code: '06', tone: 'bg-pine-700 text-parchment' },
];

export default function Hero() {
  return (
    <section className="relative pt-28 pb-16 lg:pt-36 lg:pb-24 overflow-hidden">
      <div className="absolute inset-y-0 right-0 w-1/2 hidden lg:block bg-sand/35 pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-10 items-center">
          <div className="lg:col-span-6 flex flex-col gap-7">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-copper-600">
              iqbraingamers.com · Programme personnalisé
            </p>
            <h1 className="font-display text-[3.1rem] sm:text-6xl lg:text-[4.35rem] font-semibold leading-[0.95] tracking-tight">
              Votre gymnase
              <span className="block italic text-pine-600">intérieur.</span>
            </h1>
            <p className="text-lg text-clay leading-relaxed max-w-xl">
              IQ Brain Gamers est un programme personnalisé de
              bien-être mental. Un entraînement cognitif avec plus de 50 jeux en
              ligne, disponibles en illimité pendant 3 mois, pour aiguiser votre
              mémoire et votre équilibre émotionnel.
            </p>

            <div className="flex flex-wrap items-center gap-3">
              <a
                href="/s"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-copper-500 text-paper font-bold shadow-stamp hover:bg-copper-400 transition-colors"
              >
                Entrer dans le programme
                <ArrowRight size={18} strokeWidth={2.4} />
              </a>
              <a
                href="#programme"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-md border border-ink/15 text-ink font-semibold hover:border-pine-600 hover:text-pine-600 transition-colors"
              >
                Découvrir
                <ArrowDown size={16} />
              </a>
            </div>

            <dl className="grid grid-cols-3 gap-4 pt-2 max-w-lg">
              {[
                { v: '50+', l: 'Jeux cognitifs' },
                { v: '3 mois', l: 'Accès illimité' },
                { v: '4 piliers', l: 'Approche holistique' },
              ].map((item) => (
                <div key={item.l} className="border-t-2 border-copper-500 pt-3">
                  <dt className="font-display text-2xl font-semibold text-pine-600">{item.v}</dt>
                  <dd className="text-xs text-clay mt-1 leading-snug">{item.l}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-6 relative">
            <div className="absolute -top-6 -left-4 font-mono text-[11px] uppercase tracking-[0.2em] text-clay">
              Plan du gymnase mental
            </div>
            <div className="rounded-2xl border border-sand bg-paper p-4 sm:p-5 shadow-soft">
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {ROOMS.map((room) => (
                  <div
                    key={room.code}
                    className={`gym-tile min-h-[108px] rounded-xl p-4 flex flex-col justify-between ${room.tone}`}
                  >
                    <span className="font-mono text-[10px] tracking-[0.16em] opacity-70">
                      SALLE {room.code}
                    </span>
                    <span className="font-display text-xl font-semibold">{room.name}</span>
                  </div>
                ))}
              </div>
              <div className="mt-4 flex items-center justify-between gap-3 rounded-xl bg-parchment px-4 py-3 border border-sand">
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-clay">
                    Séance du jour
                  </p>
                  <p className="font-semibold text-sm mt-0.5">Mémoire vive · 12 min · puis calme</p>
                </div>
                <a
                  href="/s"
                  className="shrink-0 px-3 py-2 rounded-md bg-pine-600 text-parchment text-xs font-bold hover:bg-pine-500 transition-colors"
                >
                  Ouvrir
                </a>
              </div>
            </div>

            <div className="hidden sm:block absolute -right-3 -bottom-5 animate-float-slow">
              <div className="rounded-xl bg-pine-600 text-parchment px-4 py-3 shadow-soft">
                <p className="font-mono text-[10px] uppercase tracking-[0.16em] opacity-70">
                  Combinaison unique
                </p>
                <p className="text-sm font-semibold mt-1">Jeux + calme + communauté</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
